import { ProductAddonCode } from '../../shared/utils/ProductEnums'

export class ProductPackage {
  constructor ({ id, name, code, monthlyFee, setupFee, addons, loyaltyLength, baseMonthlyFee, baseSetupFee, groupCode, grossMonthlyFee, grossSetupFee }) {
    this.name = name
    this.code = code
    this.monthlyFee = monthlyFee
    this.id = id
    this.setupFee = setupFee
    this.addons = addons
    this.loyaltyLength = loyaltyLength
    this.baseSetupFee = baseSetupFee
    this.baseMonthlyFee = baseMonthlyFee
    this.groupCode = groupCode
    this.grossMonthlyFee = grossMonthlyFee
    this.grossSetupFee = grossSetupFee
  }

  getTotalNetPrice (months = 1, discountsMultiplier = 1) {
    return this.monthlyFee * months * discountsMultiplier + this.getNetDevicePrice() + this.getNetInstallFee()
  }

  getTotalGrossPrice (months = 1, discountsMultiplier = 1) {
    return this.grossMonthlyFee * months * discountsMultiplier + this.getGrossDevicePrice() + this.getGrossInstallFee()
  }

  getGrossInstallFee () {
    let installAddon = this.findAddon(ProductAddonCode.SETUP_FEE)
    return installAddon ? installAddon.grossSetupFee : 0
  }

  getNetInstallFee () {
    let installAddon = this.findAddon(ProductAddonCode.SETUP_FEE)
    return installAddon ? installAddon.setupFee : 0
  }

  getGrossDevicePrice () {
    let canAddon = this.findAddon(ProductAddonCode.CAN_DEVICE)
    let trackerAddon = this.findAddon(ProductAddonCode.TRACKER)

    let canFee = canAddon ? canAddon.grossSetupFee : 0
    let trackerFee = trackerAddon ? trackerAddon.grossSetupFee : 0

    return canFee + trackerFee
  }

  getNetDevicePrice () {
    let canAddon = this.findAddon(ProductAddonCode.CAN_DEVICE)
    let trackerAddon = this.findAddon(ProductAddonCode.TRACKER)

    let canFee = canAddon ? canAddon.setupFee : 0
    let trackerFee = trackerAddon ? trackerAddon.setupFee : 0

    return canFee + trackerFee
  }

  findAddon (addonCode) {
    if (!this.addons || this.addons.length === 0) return
    for (let i = 0; i < this.addons.length; i++) {
      let addon = this.addons[i]
      if (addon.code === addonCode) {
        return addon
      }
    }

    return null
  }
}
